"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HyphenDepositWorkflowComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APLabelWithText = _interopRequireDefault(require("../../../../common/APLabelWithText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HyphenDepositWorkflowComponent = exports.HyphenDepositWorkflowComponent = function HyphenDepositWorkflowComponent(_ref) {
  var Product = _ref.product.Product,
    bankInfo = _ref.bankInfo;
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Bank Name:"),
    text: bankInfo.bankName
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Wire Number:"),
    text: bankInfo.bankWireNumber
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Account Number:"),
    text: bankInfo.bankAccountNumber
  }));
};
HyphenDepositWorkflowComponent.propTypes = {
  product: _propTypes["default"].shape({
    Product: _propTypes["default"].string.isRequired
  }).isRequired,
  bankInfo: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = HyphenDepositWorkflowComponent;